import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/hongyou/background_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validatePassword } from '@/utils/common';
import CusDialog from '@/components/dialog/index.vue';
import Crypto from '@/utils/crypto';
import { mapGetters } from 'vuex';
export default {
  name: 'CheckPassword',
  components: {
    CusDialog: CusDialog
  },
  data: function data() {
    return {
      form: {
        userId: this.$store.state.user.userId,
        username: this.$store.state.user.userName,
        pwdVal: '',
        pwd: ''
      },
      rules: {
        pwdVal: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('checkpw', ['width'])), {}, {
    dialogVisible: {
      get: function get() {
        return this.$store.getters['checkpw/visible'];
      },
      set: function set(val) {
        this.close();
        return val;
      }
    }
  }),
  methods: {
    // 关闭弹框后提示父组件
    close: function close() {
      this.$store.dispatch('checkpw/close');
    },
    submit: function submit() {
      var that = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var key = 'DIS**#KKKDJJSKDI';
          that.form.pwd = Crypto.encrypt(that.form.pwdVal, key);
          validatePassword(that.form).then(function (res) {
            if (res.code === 200) {
              that.$store.dispatch('checkpw/submit');
            } else {
              that.$notifyInfo({
                message: res.msg
              });
            }
          });
        }
      });
    }
  }
};